import Book from 'modules/BookModule/components/BookComponent';
import BookDetail from 'modules/BookModule/components/BookListComponent/BookDetailComponent';

import StudentNotificationComponent from 'modules/StudentModule/GroupComponent/StudentNotificationComponent';

// PUBLIC
import Testingmodule from 'modules/TestingModule';
// OLYMPIC
import RegisterStudent from 'modules/Login/components/RegisterStudent';
import Profile from 'pages/Profile';
import AccessDenied from 'pages/Errors/AccessDenied';
import CanvasToolPage from 'modules/TestingModule/CanvasToolPlus/CanvasToolPage';
import ExcercisePage from 'modules/TestingModule/CanvasToolPlus/ExcercisePage';
import { CURRENT_DOMAIN } from 'constants/settings';

export default [
  {
    name: 'Hướng dẫn sử dụng',
    href: `${CURRENT_DOMAIN}/templates/pdfs/HDSD-chuc-nang-Website-Sach-So-Hocvien.pdf`,
    icon: 'fas fa-file-alt text-orange',
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    showInSidebar: true,
    type: ['allowedRoutes'],
    sortOrder: 9999,
  },
  {
    path: '/access-denied',
    component: AccessDenied,
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
  },

  // {
  //   path: '/activated-books/',
  //   name: 'Sách điện tử',
  //   miniName: 'B',
  //   component: Shared_ActivatedBooks,
  //   icon: 'fas fa-book text-orange',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['authenticated'],
  //   showInSidebar: true,
  // },

  // {
  //   path: '/login',
  //   name: 'Login',
  //   miniName: 'P',
  //   component: Auth_Login,
  //   layout: '/auth',
  // },
  {
    path: '/sach-dien-tu/dashboard',
    name: 'Sách điện tử',
    miniName: 'B',
    component: Book,
    icon: 'fas fa-book text-yellow',
    // icon: "fas fa-home text-info",
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
  },
  {
    path: '/sach-dien-tu/book-detail/:id',
    name: 'Book Detail',
    miniName: 'B',
    component: BookDetail,
    icon: 'fas fa-book text-yellow',
    // icon: "fas fa-home text-info",
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
  },
  {
    path: '/notifications',
    name: 'Thông báo',
    miniName: 'B',
    component: StudentNotificationComponent,
    icon: 'fas fa-bell text-green',
    // icon: "fas fa-home text-info",
    layout: '/lms',
    exact: true,
    roles: ['student'],
  },
  {
    collapse: true,
    name: 'Examples',
    icon: 'ni ni-ungroup text-info',
    state: 'examplesCollapse',
    views: [
      {
        path: '/RegisterStudent',
        name: 'RegisterStudent',
        miniName: 'P',
        component: RegisterStudent,
        layout: '/auth',
      },
      // {
      //   path: '/RegisterTeacher',
      //   name: 'RegisterTeacher',
      //   miniName: 'P',
      //   component: RegisterTeacher,
      //   layout: '/auth',
      // },
    ],
  },
  {
    path: '/testingmodule',
    name: 'testingmodule',
    miniName: 't',
    component: Testingmodule,
    layout: '/lms',
    roles: ['authenticated'],
  },
  {
    path: '/CanvasToolPage',
    name: 'CanvasToolPage',
    miniName: 't',
    component: CanvasToolPage,
    layout: '/lms',
    roles: ['authenticated'],
  },
  {
    path: '/ExcercisePage',
    name: 'ExcercisePage',
    miniName: 't',
    component: ExcercisePage,
    layout: '/lms',
    roles: ['authenticated'],
  },
];
